import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Profile.css";
import { SidebarCol } from "../chatMain/Sidebar/Sidebar.jsx";
import { MainHeader } from "../chatMain/MainHeader/MainHeader.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../axiosconfig.js";
import { selectProfileDisplayName } from "../../store/profileSlice.js";

// Helper function to fetch the user's name from the backend
const getText = async (setName, API_URL) => {
  try {
    const responseName = await api.post(`${API_URL}/dataRequest`, {
      request: "getUserName",
    });
    setName(responseName.data.name);
  } catch (error) {
    setName("");
  }
};
export const Profile = () => {
  const navigate = useNavigate();
  const profileName = useSelector(selectProfileDisplayName);
  const [name, setName] = useState(profileName || "");
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getText(setName, API_URL);

    // Pre-fetch notification preferences so cache is warm before navigating to Notification tab
    api
      .post(`${API_URL}/profile`, { request: "getReminderData" })
      .then((res) => {
        if (res.data && res.data.result === 1 && res.data.preferences) {
          const prefs = {
            weekly_guidance: res.data.preferences.weekly_guidance !== false,
            assessment: res.data.preferences.assessment !== false,
            checkins: res.data.preferences.checkins !== false,
            sherpa: res.data.preferences.sherpa !== false,
            live_events: res.data.preferences.live_events !== false,
          };
          localStorage.setItem("mindsherpa_notification_preferences", JSON.stringify(prefs));
        }
      })
      .catch(() => {});
  }, [API_URL]);

  const activeName = profileName || name;
  return (
    <div className="profile-page">
      <div className="sidebar">
        <SidebarCol />
      </div>
      <div className="profile-container-wrapper">
        <div className="header">
          <MainHeader
            page={"profile"}
            titleText={`Welcome, ${activeName}`}
            subtitleText={"Reflecting on Loving-Kindness 💗"}
          />
        </div>
        <div className="profile-content-container">
          <div className="profile-main-content-wrapper">
            <div className="profile-index-section">
              <div className="profile-index-section-subsection-container">
                <div className="profile-index-sub-text">Home</div>
                <div className="profile-index-separator">/</div>
                <div className="profile-index-main-text">Profile</div>
              </div>
            </div>
            <div className="profile-content-section">
              <div
                className="profile-menu-item-container"
                onClick={() => navigate("/profile/edit")}
              >
                <div className="profile-menu-item">
                  <div className="profile-menu-content-container">
                    <div className="profile-menu-icon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6764)">
                          <path
                            d="M21.3112 6.87821L17.1216 2.68946C16.9823 2.55014 16.8169 2.43962 16.6349 2.36421C16.4529 2.28881 16.2578 2.25 16.0608 2.25C15.8638 2.25 15.6687 2.28881 15.4867 2.36421C15.3047 2.43962 15.1393 2.55014 15 2.68946L3.43969 14.2498C3.29979 14.3886 3.18888 14.5538 3.1134 14.7358C3.03792 14.9178 2.99937 15.113 3 15.3101V19.4998C3 19.8976 3.15804 20.2791 3.43934 20.5604C3.72064 20.8417 4.10217 20.9998 4.5 20.9998H20.25C20.4489 20.9998 20.6397 20.9208 20.7803 20.7801C20.921 20.6395 21 20.4487 21 20.2498C21 20.0509 20.921 19.8601 20.7803 19.7194C20.6397 19.5788 20.4489 19.4998 20.25 19.4998H10.8112L21.3112 8.99977C21.4506 8.86048 21.5611 8.69511 21.6365 8.5131C21.7119 8.33109 21.7507 8.136 21.7507 7.93899C21.7507 7.74198 21.7119 7.5469 21.6365 7.36489C21.5611 7.18288 21.4506 7.0175 21.3112 6.87821ZM18 10.1895L13.8112 5.99977L16.0612 3.74977L20.25 7.93946L18 10.1895Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6764">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="profile-menu-text">Edit Profile</div>
                    <div className="profile-menu-link">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6701)">
                          <path
                            d="M17.7075 11.2933L7.7075 1.29329C7.56765 1.15328 7.38939 1.05791 7.19531 1.01926C7.00122 0.980608 6.80003 1.00041 6.61721 1.07616C6.43439 1.15192 6.27815 1.28021 6.16828 1.44481C6.05841 1.6094 5.99984 1.80289 6 2.00079V22.0008C5.99984 22.1987 6.05841 22.3922 6.16828 22.5568C6.27815 22.7214 6.43439 22.8497 6.61721 22.9254C6.80003 23.0012 7.00122 23.021 7.19531 22.9823C7.38939 22.9437 7.56765 22.8483 7.7075 22.7083L17.7075 12.7083C17.8005 12.6154 17.8742 12.5051 17.9246 12.3837C17.9749 12.2623 18.0008 12.1322 18.0008 12.0008C18.0008 11.8694 17.9749 11.7392 17.9246 11.6178C17.8742 11.4964 17.8005 11.3862 17.7075 11.2933Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6701">
                            <rect
                              width="32"
                              height="32"
                              fill="white"
                              transform="translate(-4 -4)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div
                className="profile-menu-item-container"
                onClick={() => navigate("/profile/language")}
              >
                <div className="profile-menu-item">
                  <div className="profile-menu-content-container">
                    <div className="profile-menu-icon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6771)">
                          <path
                            d="M15 12.1772L16.4119 15H13.5881L14.1844 13.8094L15 12.1772ZM21 4.5V19.5C21 19.8978 20.842 20.2794 20.5607 20.5607C20.2794 20.842 19.8978 21 19.5 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607C3.15804 20.2794 3 19.8978 3 19.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H19.5C19.8978 3 20.2794 3.15804 20.5607 3.43934C20.842 3.72064 21 4.10218 21 4.5ZM19.4212 17.6644L15.6713 10.1644C15.609 10.0396 15.5133 9.93458 15.3947 9.86119C15.2761 9.7878 15.1394 9.74892 15 9.74892C14.8606 9.74892 14.7239 9.7878 14.6053 9.86119C14.4867 9.93458 14.391 10.0396 14.3287 10.1644L13.0931 12.6375C12.2983 12.4818 11.5445 12.1626 10.8797 11.7C11.9159 10.5268 12.5571 9.05756 12.7125 7.5H14.25C14.4489 7.5 14.6397 7.42098 14.7803 7.28033C14.921 7.13968 15 6.94891 15 6.75C15 6.55109 14.921 6.36032 14.7803 6.21967C14.6397 6.07902 14.4489 6 14.25 6H10.5V5.25C10.5 5.05109 10.421 4.86032 10.2803 4.71967C10.1397 4.57902 9.94891 4.5 9.75 4.5C9.55109 4.5 9.36032 4.57902 9.21967 4.71967C9.07902 4.86032 9 5.05109 9 5.25V6H5.25C5.05109 6 4.86032 6.07902 4.71967 6.21967C4.57902 6.36032 4.5 6.55109 4.5 6.75C4.5 6.94891 4.57902 7.13968 4.71967 7.28033C4.86032 7.42098 5.05109 7.5 5.25 7.5H11.2013C11.0525 8.68338 10.5529 9.79515 9.76688 10.6922C9.43388 10.3035 9.15046 9.87486 8.92313 9.41625C8.83101 9.24448 8.67565 9.11532 8.48994 9.05612C8.30424 8.99693 8.10279 9.01235 7.92826 9.09913C7.75373 9.18591 7.61984 9.33722 7.55495 9.52101C7.49006 9.7048 7.49927 9.90663 7.58063 10.0837C7.86768 10.6626 8.22678 11.2028 8.64937 11.6916C7.65044 12.3822 6.46446 12.7515 5.25 12.75C5.05109 12.75 4.86032 12.829 4.71967 12.9697C4.57902 13.1103 4.5 13.3011 4.5 13.5C4.5 13.6989 4.57902 13.8897 4.71967 14.0303C4.86032 14.171 5.05109 14.25 5.25 14.25C6.87819 14.2517 8.46222 13.7206 9.76031 12.7378C10.5458 13.3382 11.4443 13.7737 12.4022 14.0184L10.5787 17.6644C10.4897 17.8424 10.4751 18.0485 10.538 18.2373C10.601 18.4261 10.7363 18.5822 10.9144 18.6713C11.0924 18.7603 11.2985 18.7749 11.4873 18.712C11.6761 18.649 11.8322 18.5137 11.9213 18.3356L12.8381 16.5H17.1619L18.0787 18.3356C18.1228 18.4238 18.1838 18.5024 18.2583 18.567C18.3327 18.6315 18.4192 18.6808 18.5127 18.712C18.6062 18.7431 18.7049 18.7556 18.8032 18.7486C18.9015 18.7416 18.9975 18.7153 19.0856 18.6713C19.1738 18.6272 19.2524 18.5662 19.317 18.4917C19.3815 18.4173 19.4308 18.3308 19.462 18.2373C19.4931 18.1438 19.5056 18.0451 19.4986 17.9468C19.4916 17.8485 19.4653 17.7525 19.4212 17.6644Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6771">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="profile-menu-text">
                      Language Preferences
                    </div>
                    <div className="profile-menu-link">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6701)">
                          <path
                            d="M17.7075 11.2933L7.7075 1.29329C7.56765 1.15328 7.38939 1.05791 7.19531 1.01926C7.00122 0.980608 6.80003 1.00041 6.61721 1.07616C6.43439 1.15192 6.27815 1.28021 6.16828 1.44481C6.05841 1.6094 5.99984 1.80289 6 2.00079V22.0008C5.99984 22.1987 6.05841 22.3922 6.16828 22.5568C6.27815 22.7214 6.43439 22.8497 6.61721 22.9254C6.80003 23.0012 7.00122 23.021 7.19531 22.9823C7.38939 22.9437 7.56765 22.8483 7.7075 22.7083L17.7075 12.7083C17.8005 12.6154 17.8742 12.5051 17.9246 12.3837C17.9749 12.2623 18.0008 12.1322 18.0008 12.0008C18.0008 11.8694 17.9749 11.7392 17.9246 11.6178C17.8742 11.4964 17.8005 11.3862 17.7075 11.2933Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6701">
                            <rect
                              width="32"
                              height="32"
                              fill="white"
                              transform="translate(-4 -4)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div> */}
              <div
                className="profile-menu-item-container"
                onClick={() => navigate("/profile/password")}
              >
                <div className="profile-menu-item">
                  <div className="profile-menu-content-container">
                    <div className="profile-menu-icon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6791)">
                          <path
                            d="M21 4.5H3C2.60218 4.5 2.22064 4.65804 1.93934 4.93934C1.65804 5.22064 1.5 5.60218 1.5 6V18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5H21C21.3978 19.5 21.7794 19.342 22.0607 19.0607C22.342 18.7794 22.5 18.3978 22.5 18V6C22.5 5.60218 22.342 5.22064 22.0607 4.93934C21.7794 4.65804 21.3978 4.5 21 4.5ZM19.1794 13.3791C19.2373 13.4591 19.2789 13.5497 19.3018 13.6458C19.3247 13.7419 19.3284 13.8416 19.3128 13.9391C19.2972 14.0367 19.2625 14.1302 19.2107 14.2143C19.1589 14.2985 19.0911 14.3716 19.0111 14.4295C18.9311 14.4875 18.8404 14.5291 18.7443 14.5519C18.6482 14.5748 18.5486 14.5786 18.451 14.563C18.3535 14.5473 18.26 14.5126 18.1758 14.4609C18.0917 14.4091 18.0186 14.3413 17.9606 14.2612L17.25 13.2759L16.5347 14.2612C16.4177 14.4229 16.2413 14.5314 16.0443 14.563C15.8473 14.5945 15.6458 14.5465 15.4842 14.4295C15.3226 14.3125 15.2141 14.1361 15.1825 13.9391C15.151 13.7421 15.199 13.5407 15.3159 13.3791L16.0322 12.3947L14.8734 12.0197C14.7798 11.9889 14.6932 11.94 14.6184 11.8757C14.5437 11.8115 14.4824 11.7331 14.4379 11.6451C14.3482 11.4675 14.3327 11.2614 14.3948 11.0723C14.4256 10.9787 14.4745 10.8921 14.5388 10.8173C14.6031 10.7426 14.6814 10.6813 14.7694 10.6368C14.9471 10.5471 15.1531 10.5316 15.3422 10.5938L16.5 10.9688V9.75C16.5 9.55109 16.579 9.36032 16.7197 9.21967C16.8603 9.07902 17.0511 9 17.25 9C17.4489 9 17.6397 9.07902 17.7803 9.21967C17.921 9.36032 18 9.55109 18 9.75V10.9688L19.1578 10.5938C19.2514 10.563 19.3502 10.5509 19.4485 10.5583C19.5468 10.5657 19.6426 10.5924 19.7306 10.6368C19.8186 10.6813 19.8969 10.7426 19.9612 10.8173C20.0255 10.8921 20.0744 10.9787 20.1052 11.0723C20.1359 11.166 20.148 11.2647 20.1406 11.363C20.1332 11.4613 20.1065 11.5572 20.0621 11.6451C20.0176 11.7331 19.9563 11.8115 19.8816 11.8757C19.8068 11.94 19.7202 11.9889 19.6266 12.0197L18.4678 12.3947L19.1794 13.3791ZM12.4294 13.3791C12.4873 13.4591 12.5289 13.5497 12.5518 13.6458C12.5747 13.7419 12.5784 13.8416 12.5628 13.9391C12.5472 14.0367 12.5125 14.1302 12.4607 14.2143C12.4089 14.2985 12.3411 14.3716 12.2611 14.4295C12.1811 14.4875 12.0904 14.5291 11.9943 14.5519C11.8982 14.5748 11.7986 14.5786 11.701 14.563C11.6035 14.5473 11.5099 14.5126 11.4258 14.4609C11.3417 14.4091 11.2686 14.3413 11.2106 14.2612L10.5 13.2759L9.78469 14.2612C9.6677 14.4229 9.49131 14.5314 9.29431 14.563C9.0973 14.5945 8.89583 14.5465 8.73422 14.4295C8.5726 14.3125 8.46408 14.1361 8.43252 13.9391C8.40096 13.7421 8.44895 13.5407 8.56594 13.3791L9.28219 12.3947L8.12344 12.0197C8.02981 11.9889 7.94316 11.94 7.86844 11.8757C7.79371 11.8115 7.73238 11.7331 7.68794 11.6451C7.59819 11.4675 7.58268 11.2614 7.64484 11.0723C7.67562 10.9787 7.72454 10.8921 7.78881 10.8173C7.85307 10.7426 7.93143 10.6813 8.0194 10.6368C8.19706 10.5471 8.4031 10.5316 8.59219 10.5938L9.75 10.9688V9.75C9.75 9.55109 9.82902 9.36032 9.96967 9.21967C10.1103 9.07902 10.3011 9 10.5 9C10.6989 9 10.8897 9.07902 11.0303 9.21967C11.171 9.36032 11.25 9.55109 11.25 9.75V10.9688L12.4078 10.5938C12.5014 10.563 12.6002 10.5509 12.6985 10.5583C12.7968 10.5657 12.8926 10.5924 12.9806 10.6368C13.0686 10.6813 13.1469 10.7426 13.2112 10.8173C13.2755 10.8921 13.3244 10.9787 13.3552 11.0723C13.3859 11.166 13.398 11.2647 13.3906 11.363C13.3832 11.4613 13.3565 11.5572 13.3121 11.6451C13.2676 11.7331 13.2063 11.8115 13.1316 11.8757C13.0568 11.94 12.9702 11.9889 12.8766 12.0197L11.7178 12.3947L12.4294 13.3791ZM6 8.25V15.75C6 15.9489 5.92098 16.1397 5.78033 16.2803C5.63968 16.421 5.44891 16.5 5.25 16.5C5.05109 16.5 4.86032 16.421 4.71967 16.2803C4.57902 16.1397 4.5 15.9489 4.5 15.75V8.25C4.5 8.05109 4.57902 7.86032 4.71967 7.71967C4.86032 7.57902 5.05109 7.5 5.25 7.5C5.44891 7.5 5.63968 7.57902 5.78033 7.71967C5.92098 7.86032 6 8.05109 6 8.25Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6791">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="profile-menu-text">Change Password</div>
                    <div className="profile-menu-link">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6701)">
                          <path
                            d="M17.7075 11.2933L7.7075 1.29329C7.56765 1.15328 7.38939 1.05791 7.19531 1.01926C7.00122 0.980608 6.80003 1.00041 6.61721 1.07616C6.43439 1.15192 6.27815 1.28021 6.16828 1.44481C6.05841 1.6094 5.99984 1.80289 6 2.00079V22.0008C5.99984 22.1987 6.05841 22.3922 6.16828 22.5568C6.27815 22.7214 6.43439 22.8497 6.61721 22.9254C6.80003 23.0012 7.00122 23.021 7.19531 22.9823C7.38939 22.9437 7.56765 22.8483 7.7075 22.7083L17.7075 12.7083C17.8005 12.6154 17.8742 12.5051 17.9246 12.3837C17.9749 12.2623 18.0008 12.1322 18.0008 12.0008C18.0008 11.8694 17.9749 11.7392 17.9246 11.6178C17.8742 11.4964 17.8005 11.3862 17.7075 11.2933Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6701">
                            <rect
                              width="32"
                              height="32"
                              fill="white"
                              transform="translate(-4 -4)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="profile-menu-item-container"
                onClick={() => navigate("/profile/notification")}
              >
                <div className="profile-menu-item">
                  <div className="profile-menu-content-container">
                    <div className="profile-menu-icon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6787)">
                          <path
                            d="M20.7937 16.4944C20.2734 15.5981 19.5 13.0622 19.5 9.75C19.5 7.76088 18.7098 5.85322 17.3033 4.4467C15.8968 3.04018 13.9891 2.25 12 2.25C10.0109 2.25 8.10322 3.04018 6.6967 4.4467C5.29017 5.85322 4.5 7.76088 4.5 9.75C4.5 13.0631 3.72562 15.5981 3.20531 16.4944C3.07244 16.7222 3.002 16.9811 3.00109 17.2449C3.00019 17.5086 3.06885 17.768 3.20015 17.9967C3.33146 18.2255 3.52076 18.4156 3.74897 18.5478C3.97718 18.6801 4.23623 18.7498 4.5 18.75H8.32593C8.49897 19.5967 8.95914 20.3577 9.62862 20.9042C10.2981 21.4507 11.1358 21.7492 12 21.7492C12.8642 21.7492 13.7019 21.4507 14.3714 20.9042C15.0408 20.3577 15.501 19.5967 15.6741 18.75H19.5C19.7637 18.7496 20.0226 18.6798 20.2507 18.5475C20.4788 18.4151 20.6679 18.225 20.7991 17.9963C20.9303 17.7676 20.9989 17.5083 20.998 17.2446C20.997 16.9809 20.9266 16.7222 20.7937 16.4944ZM12 20.25C11.5348 20.2499 11.0811 20.1055 10.7014 19.8369C10.3216 19.5683 10.0344 19.1886 9.87937 18.75H14.1206C13.9656 19.1886 13.6784 19.5683 13.2986 19.8369C12.9189 20.1055 12.4652 20.2499 12 20.25Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6787">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="profile-menu-text">
                      Notification Settings
                    </div>
                    <div className="profile-menu-link">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6701)">
                          <path
                            d="M17.7075 11.2933L7.7075 1.29329C7.56765 1.15328 7.38939 1.05791 7.19531 1.01926C7.00122 0.980608 6.80003 1.00041 6.61721 1.07616C6.43439 1.15192 6.27815 1.28021 6.16828 1.44481C6.05841 1.6094 5.99984 1.80289 6 2.00079V22.0008C5.99984 22.1987 6.05841 22.3922 6.16828 22.5568C6.27815 22.7214 6.43439 22.8497 6.61721 22.9254C6.80003 23.0012 7.00122 23.021 7.19531 22.9823C7.38939 22.9437 7.56765 22.8483 7.7075 22.7083L17.7075 12.7083C17.8005 12.6154 17.8742 12.5051 17.9246 12.3837C17.9749 12.2623 18.0008 12.1322 18.0008 12.0008C18.0008 11.8694 17.9749 11.7392 17.9246 11.6178C17.8742 11.4964 17.8005 11.3862 17.7075 11.2933Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6701">
                            <rect
                              width="32"
                              height="32"
                              fill="white"
                              transform="translate(-4 -4)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
